var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({class:( _obj = {}, _obj[_vm.classWhenInView] = _vm.inView, _obj ),attrs:{"viewBox":_vm.viewbox}},'svg',_vm.$attrs,false),[_c('circle',{staticClass:"fix-transiton-stroke-dashoffset duration-1000 delay-inherited origin-center -rotate-[135deg]",style:(_vm.style),attrs:{"cx":_vm.r,"cy":_vm.r,"r":_vm.r - 1,"stroke":"currentcolor","fill":"none"}})])}
var staticRenderFns = []

export { render, staticRenderFns }